import NotificationSocket, {
  NotificationSocketEvents,
  SocketResponseError,
} from '../api/sockets/NotificationSocket';
import { Dict } from '../types/utility';
import { getErrorMessage } from '@/utils/errorHelpers';

export enum ToastMessages {
  ON_ERROR = 'Error',
}

export type ToastManager = {
  showError(message: string): void;
};

type UiInteractorNames = 'error';

export type UiInteractors = {
  [key in UiInteractorNames]?: (data: Dict) => void;
};

export default class NotificationService {
  private notificationSocket: NotificationSocket;

  constructor(
    email: string,
    private toastManager: ToastManager,
    private uiInteractors: UiInteractors,
  ) {
    this.notificationSocket = NotificationSocket.start(email);

    this.initListeners();
  }

  public disconnect() {
    this.notificationSocket.close();
  }

  private initListeners() {
    this.notificationSocket.addEventListener(NotificationSocketEvents.ERROR, (e) =>
      this.onError(e),
    );
  }

  private onError(data: SocketResponseError) {
    const error = getErrorMessage(data.code) ?? 'Unknown error';
    this.toastManager.showError(`${ToastMessages.ON_ERROR}: ${error}`);
    this.uiInteractors['error']?.(data);
  }
}
